// Import normalizr library
import {schema} from 'normalizr'

/*** rgv schemas ***/
// imports schema
const importRecord = new schema.Entity('imports')
export const importSchema = { imports: importRecord }
export const importsSchema = { imports: { 'collection': [importRecord] } }

// tags schema
const tag = new schema.Entity('tags')
export const tagSchema = { tag: tag }
export const tagsSchema = { tags: { 'collection': [tag] } }
// bookmarks schema
const bookmark = new schema.Entity('bookmarks', { tags: [tag] })
export const bookmarkSchema = { bookmark: bookmark }
export const bookmarksSchema = { bookmarks: { 'collection': [bookmark] } }

const user = new schema.Entity('users')
export const userSchema = { user: user }
export const usersSchema = { users: { 'collection': [user] } }
